<template>
    <div>
        <el-dialog :title="mainTitle" :visible.sync="editVisible" :modal-append-to-body="false" width="600px" @close="closeEdit" @open="dlgOpen" @closed="dlgClosed" :close-on-click-modal="false">
            <el-form inline ref="form" :model="form" :rules="rules" label-width="150px" v-loading="loading">
                <el-form-item label="学生校区：">
                    <el-input disabled v-model="regionName" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item label="故障类型：">
                    <el-input disabled v-model="faulttypeName" style="width:250px"></el-input>
                </el-form-item>
                <el-form-item label="工程师所属校区：" prop="region">
                    <el-select v-model="form.region" placeholder="请选择" @change="qryEngineer" style="width:250px">
                        <el-option v-for="item in xqqys" :key="item.id" :label="item.name" :value="item.extCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工程师：" prop="repersonnel">
                    <el-select v-model="form.repersonnel" placeholder="请选择" style="width:250px">
                        <el-option v-for="item in gcsdate" :key="item.id" :label="item.realName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" @click="saveChange('form')">转单</el-button>
                <el-button type="primary" plain @click="clones">返回</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import FaultApi from "@/api/fault.js";
import DialogResize from "@/utils/DialogResize.js";

export default {
    mixins: [DialogResize],
    components: {},

    data () {
        return {
            tabName: "",
            xqqys: [],//校区
            loading: false,
            mainTitle: "转单",
            editVisible: false,
            regionName: "",
            faulttypeName: "",
            repaircode: "",
            parentson: "",
            gcsdate: [],
            form: {
                region: "",
                repersonnel: ""
            },
            rules: {
                region: [
                    {
                        required: true,
                        message: "工程师所属校区不能为空",
                        trigger: "change"
                    }
                ],
                repersonnel: [
                    {
                        required: true,
                        message: "工程师不能为空",
                        trigger: "change"
                    }
                ]
            }
        }
    },

    mounted: function () {
        this.findOptions("1003", "xqqys");
    },

    methods: {
        init (row, tabName) {
            this.tabName = tabName;
            this.editVisible = true;
            this.regionName = row.regionName;
            this.faulttypeName = row.faulttypeName;
            this.repaircode = row.repaircode;
            this.clear();
        },

        qryEngineer (event) {
            SettingApi.getClass()
                .qryEngineer(event)
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.gcsdate = resp.data.data;
                    } else {
                        this.btnDisabled = false;
                        this.$message.error(resp.data.msg);
                    }
                }).catch(err => {
                    this.btnDisabled = false;
                    this.$message.error(err);
                });
            this.loading = false;
        },

        saveChange (frm) {
            this.$refs[frm].validate((valid) => {
                if (valid) {
                    for (let b in this.xqqys) {
                        if (this.xqqys[b].extCode == this.form.region) {
                            this.form.region = this.xqqys[b].code;
                            break;
                        }
                    }
                    let param = {
                        schoolCode: this.form.region,
                        toUserId: this.form.repersonnel,
                        repaircode: this.repaircode,
                    }
                    FaultApi.getClass()
                        .changeOrder(param)
                        .then(resp => {
                            if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                                this.$message.success("保存成功！");
                                this.loading = false;
                                this.editVisible = false;
                                this.$parent.initData(this.tabName);
                            } else {
                                this.$message.error(resp.data.msg);
                            }
                        }).catch(err => {
                            this.loading = false;
                            this.$message.error(err);
                        });
                }
            });
        },

        findOptions (code, key) {
            SettingApi.getClass()
                .Findcode(code)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this[key] = resp.data.data;
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        closeEdit () { },
        clear () {
            this.form = {
                region: "",
                repersonnel: ""
            };
            this.gcsdate = [];
        },
        clones () {
            this.editVisible = false;
        }
    }
}
</script>